var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenCheckOpacity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 0C3.63401 0 0.5 3.13401 0.5 7C0.5 10.866 3.63401 14 7.5 14C11.366 14 14.5 10.866 14.5 7C14.5 3.13401 11.366 0 7.5 0ZM3.49563 7.2817L5.78171 9.56779L11.1793 4.17079C11.2887 4.06143 11.437 4 11.5917 4C11.7464 4 11.8947 4.06143 12.0041 4.17079C12.1135 4.28018 12.1749 4.42853 12.1749 4.58321C12.1749 4.73789 12.1135 4.88623 12.0041 4.99562L6.60713 10.3926C6.49878 10.501 6.37015 10.587 6.22857 10.6456C6.087 10.7043 5.93525 10.7345 5.782 10.7345C5.62875 10.7345 5.47701 10.7043 5.33543 10.6456C5.19385 10.587 5.06522 10.501 4.95688 10.3926L2.67079 8.10654C2.56143 7.99715 2.5 7.8488 2.5 7.69412C2.5 7.53944 2.56143 7.3911 2.67079 7.2817C2.78018 7.17235 2.92853 7.11091 3.08321 7.11091C3.23789 7.11091 3.38623 7.17235 3.49563 7.2817Z",
    fill: "white",
    fillOpacity: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCheckOpacity);
export default __webpack_public_path__ + "static/media/green-check-opacity.c83066eee9ec260c836085b707a92d35.svg";
export { ForwardRef as ReactComponent };